import { Action } from "@reduxjs/toolkit";
import { isType } from "typescript-fsa";
import { bannerActions } from "./actions";
import { BannerState } from "./types";

const initialState: BannerState = {
  banners: [],
};

export function BannerReducer(
  state = initialState,
  action: Action,
): BannerState {
  if (isType(action, bannerActions.getBanners.done)) {
    return {
      ...state,
      banners: action.payload.result.sort((a, b) => a.sortOrder - b.sortOrder),
    };
  }

  if (isType(action, bannerActions.resetToInitialState)) {
    return initialState;
  }

  return state;
}
